"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateImages = exports.getModality = exports.PalmPrintPositionMap = exports.ModalityBioTypeMap = exports.BioType = exports.Modality = void 0;
var Modality;
(function (Modality) {
    Modality["Face"] = "Face";
    Modality["SMT"] = "SMT";
    Modality["Fingerprint"] = "Fingerprint";
    Modality["Palm"] = "Palm";
    Modality["Iris"] = "Iris";
})(Modality = exports.Modality || (exports.Modality = {}));
// TODO: Construct a reverse mapping to resolve 10.003 ImageType to the correct BioType
var BioType;
(function (BioType) {
    BioType["FaceFront"] = "FaceFront";
    BioType["FaceLeft45"] = "FaceLeft45";
    BioType["FaceLeft90"] = "FaceLeft90";
    BioType["FaceRight45"] = "FaceRight45";
    BioType["FaceRight90"] = "FaceRight90";
    BioType["FullBody"] = "FullBody";
    BioType["SMT"] = "SMT";
    BioType["LeftThumbFlat"] = "LeftThumbFlat";
    BioType["LeftIndexFlat"] = "LeftIndexFlat";
    BioType["LeftMiddleFlat"] = "LeftMiddleFlat";
    BioType["LeftRingFlat"] = "LeftRingFlat";
    BioType["LeftLittleFlat"] = "LeftLittleFlat";
    BioType["RightThumbFlat"] = "RightThumbFlat";
    BioType["RightIndexFlat"] = "RightIndexFlat";
    BioType["RightMiddleFlat"] = "RightMiddleFlat";
    BioType["RightRingFlat"] = "RightRingFlat";
    BioType["RightLittleFlat"] = "RightLittleFlat";
    BioType["LeftThumbRoll"] = "LeftThumbRoll";
    BioType["LeftIndexRoll"] = "LeftIndexRoll";
    BioType["LeftMiddleRoll"] = "LeftMiddleRoll";
    BioType["LeftRingRoll"] = "LeftRingRoll";
    BioType["LeftLittleRoll"] = "LeftLittleRoll";
    BioType["RightThumbRoll"] = "RightThumbRoll";
    BioType["RightIndexRoll"] = "RightIndexRoll";
    BioType["RightMiddleRoll"] = "RightMiddleRoll";
    BioType["RightRingRoll"] = "RightRingRoll";
    BioType["RightLittleRoll"] = "RightLittleRoll";
    BioType["LeftFourSlap"] = "LeftFourSlap";
    BioType["RightFourSlap"] = "RightFourSlap";
    BioType["TwoThumbSlap"] = "TwoThumbSlap";
    BioType["FBICard"] = "FBICard";
    BioType["LeftFullPalm"] = "LeftFullPalm";
    BioType["LeftHypothenar"] = "LeftHypothenar";
    BioType["LeftLowerPalm"] = "LeftLowerPalm";
    BioType["LeftUpperPalm"] = "LeftUpperPalm";
    BioType["RightFullPalm"] = "RightFullPalm";
    BioType["RightHypothenar"] = "RightHypothenar";
    BioType["RightLowerPalm"] = "RightLowerPalm";
    BioType["RightUpperPalm"] = "RightUpperPalm";
    BioType["LeftIris"] = "LeftIris";
    BioType["RightIris"] = "RightIris";
})(BioType = exports.BioType || (exports.BioType = {}));
exports.ModalityBioTypeMap = {
    [Modality.Face]: [
        BioType.FaceFront,
        BioType.FaceLeft45,
        BioType.FaceLeft90,
        BioType.FaceRight45,
        BioType.FaceRight90,
        BioType.FullBody
    ],
    [Modality.SMT]: [
        BioType.SMT // Comment here for styling purposes
    ],
    [Modality.Fingerprint]: [
        BioType.LeftThumbFlat,
        BioType.LeftIndexFlat,
        BioType.LeftMiddleFlat,
        BioType.LeftRingFlat,
        BioType.LeftLittleFlat,
        BioType.RightThumbFlat,
        BioType.RightIndexFlat,
        BioType.RightMiddleFlat,
        BioType.RightRingFlat,
        BioType.RightLittleFlat,
        BioType.LeftThumbRoll,
        BioType.LeftIndexRoll,
        BioType.LeftMiddleRoll,
        BioType.LeftRingRoll,
        BioType.LeftLittleRoll,
        BioType.RightThumbRoll,
        BioType.RightIndexRoll,
        BioType.RightMiddleRoll,
        BioType.RightRingRoll,
        BioType.RightLittleRoll,
        BioType.LeftFourSlap,
        BioType.RightFourSlap,
        BioType.TwoThumbSlap
    ],
    [Modality.Palm]: [
        BioType.LeftFullPalm,
        BioType.LeftHypothenar,
        BioType.LeftLowerPalm,
        BioType.LeftUpperPalm,
        BioType.RightFullPalm,
        BioType.RightHypothenar,
        BioType.RightLowerPalm,
        BioType.RightUpperPalm
    ],
    [Modality.Iris]: [BioType.LeftIris, BioType.RightIris]
};
// Used for Palmprint Position T15_PLP 15.013
exports.PalmPrintPositionMap = {
    [BioType.RightFullPalm]: '21',
    [BioType.LeftFullPalm]: '23',
    [BioType.RightLowerPalm]: '25',
    [BioType.RightUpperPalm]: '26',
    [BioType.LeftLowerPalm]: '27',
    [BioType.LeftUpperPalm]: '28',
    [BioType.RightHypothenar]: '33',
    [BioType.LeftHypothenar]: '36'
};
// typescript magic from: https://stackoverflow.com/a/63520989/9778302
function objectKeys(obj) {
    return Object.keys(obj);
}
function getModality(bioType) {
    for (const modality of objectKeys(Modality)) {
        if (exports.ModalityBioTypeMap[modality].includes(bioType)) {
            return Modality[modality];
        }
    }
    throw new Error('Modality not found for bio type: ' + bioType);
}
exports.getModality = getModality;
function validateImages(jfd) {
    return [...validateModalities(jfd), ...validateBioTypes(jfd)];
}
exports.validateImages = validateImages;
function validateModalities(jfd) {
    const imagesDef = jfd.jfdDef.images;
    let result = [];
    objectKeys(imagesDef.modalities).forEach((modality) => {
        const modalityDef = imagesDef.modalities[modality];
        if (modalityDef) {
            if (modality.includes('+')) {
                result = [...result, ...validateModalityAsString(jfd, modality)];
            }
            else {
                result = [...result, ...validateModalityAsObject(jfd, modality)];
            }
        }
    });
    return result;
}
/**
 * @param jfd
 * @param modalities A plus-separated string of modalities, e.g. "Face+Palm+Fingerprint
 */
function validateModalityAsString(jfd, modalities) {
    const result = [];
    const modalityDef = jfd.jfdDef.images.modalities[modalities];
    const allModalities = modalities.split('+').map((m) => m);
    const allModalitiesStr = modalities.split('+').join(' or ');
    // check that the string contains only valid modalities
    allModalities.forEach((m) => {
        if (!Object.values(Modality).includes(m)) {
            throw new Error('Invalid modality: ' + m);
        }
    });
    // check for min/max occurrences for the modality array
    const imageCount = allModalities
        .map((modality) => jfd.getImages({ modality }))
        .reduce((prev, curr) => prev + curr.length, 0);
    if (imageCount < modalityDef.minOccurrences) {
        result.push({
            type: 'modalities',
            modalities: allModalities,
            error: `Min ${modalityDef.minOccurrences} ${allModalitiesStr} image is required`
        });
    }
    if (imageCount > modalityDef.maxOccurrences) {
        result.push({
            type: 'modalities',
            modalities: allModalities,
            error: `Max limit of ${modalityDef.maxOccurrences} ${allModalitiesStr} exceeded`
        });
    }
    return result;
}
function validateModalityAsObject(jfd, modality) {
    const modalityDef = jfd.jfdDef.images.modalities[modality];
    if (!modalityDef) {
        return [];
    }
    const result = [];
    const images = jfd.getImages({ modality });
    if (images.length < modalityDef.minOccurrences && modalityDef.minOccurrences > 0) {
        result.push({
            type: 'modality',
            modality,
            error: `Min ${modalityDef.minOccurrences} ${modality} image is required`
        });
    }
    if (images.length > modalityDef.maxOccurrences && modalityDef.maxOccurrences > 0) {
        result.push({
            type: 'modality',
            modality,
            error: `Max limit of ${modalityDef.maxOccurrences} ${modality} exceeded`
        });
    }
    return result;
}
function validateBioTypes(jfd) {
    const imagesDef = jfd.jfdDef.images;
    const result = [];
    objectKeys(imagesDef.bioTypes).forEach((bioType) => {
        const bioTypeDef = imagesDef.bioTypes[bioType];
        if (!bioTypeDef) {
            return;
        }
        const groups = jfd.getModalityGroups(getModality(bioType));
        for (const group of groups) {
            const groupBioTypes = new Set(group.images.map((img) => img.bioType));
            if (!groupBioTypes.has(bioType)) {
                result.push({
                    type: 'groupBioType',
                    groupId: group.groupId,
                    bioType,
                    error: `${bioType} is required`
                });
            }
        }
    });
    return result;
}
//# sourceMappingURL=jfd-images.js.map